export default "__VITE_ASSET__0pW6QF0f__"